export type Locale = "ru" | "en";

export const messages = {
  ru: {
    appTitle: "demo-messenger",
    tabMax: "MAX",
    tabTelegram: "Telegram",
    tabWhatsapp: "WhatsApp",
    settings: "Настройки",
    settingsTitle: "GREEN-API",
    apiUrl: "apiUrl",
    idInstance: "idInstance",
    apiTokenInstance: "apiTokenInstance",
    save: "Сохранить",
    clear: "Очистить",
    cancel: "Отмена",
    language: "Язык",
    newChat: "Новый чат",
    phone: "Номер телефона",
    phoneHintMax: "Например +7 999 123-45-67 — chatId через checkAccount",
    phoneHintTelegram: "Номер или chatId (7999…@c.us)",
    phoneHintWhatsapp: "Номер или chatId (7999…@c.us)",
    create: "Создать",
    noChats: "Нет чатов",
    noChatsHint: "Создайте чат по номеру получателя",
    typeMessage: "Сообщение…",
    send: "Отправить",
    needSettings: "Укажите учётные данные GREEN-API в настройках",
    checking: "Проверка инстанса…",
    authorized: "Инстанс авторизован",
    notAuthorized: "Инстанс не авторизован",
    sent: "Отправлено",
    sendFailed: "Не удалось отправить",
    chatCreated: "Чат создан",
    chatFailed: "Не удалось создать чат",
    receiving: "Ожидание сообщений…",
    saved: "Сохранено",
    cleared: "Данные удалены",
    selectChat: "Выберите чат",
    online: "в сети",
    disconnect: "Отключить приём",
    connect: "Включить приём",
  },
  en: {
    appTitle: "demo-messenger",
    tabMax: "MAX",
    tabTelegram: "Telegram",
    tabWhatsapp: "WhatsApp",
    settings: "Settings",
    settingsTitle: "GREEN-API",
    apiUrl: "apiUrl",
    idInstance: "idInstance",
    apiTokenInstance: "apiTokenInstance",
    save: "Save",
    clear: "Clear",
    cancel: "Cancel",
    language: "Language",
    newChat: "New chat",
    phone: "Phone number",
    phoneHintMax: "e.g. +7 999 123-45-67 — chatId via checkAccount",
    phoneHintTelegram: "Phone or chatId (7999…@c.us)",
    phoneHintWhatsapp: "Phone or chatId (7999…@c.us)",
    create: "Create",
    noChats: "No chats",
    noChatsHint: "Create a chat with the recipient phone",
    typeMessage: "Message…",
    send: "Send",
    needSettings: "Enter GREEN-API credentials in settings",
    checking: "Checking instance…",
    authorized: "Instance authorized",
    notAuthorized: "Instance not authorized",
    sent: "Sent",
    sendFailed: "Failed to send",
    chatCreated: "Chat created",
    chatFailed: "Failed to create chat",
    receiving: "Listening for messages…",
    saved: "Saved",
    cleared: "Cleared",
    selectChat: "Select a chat",
    online: "online",
    disconnect: "Stop receiving",
    connect: "Start receiving",
  },
} as const;

export type MessageKey = keyof (typeof messages)["ru"];
